import { useAuth } from '../contexts/AuthContext'
import { useLocation } from 'react-router-dom'

export default function DebugInfo() {
  const { user, isAuthenticated, isLoading, error } = useAuth()
  const location = useLocation()

  if (import.meta.env.MODE !== 'development') {
    return null
  }

  return (
    <div className="fixed bottom-4 right-4 bg-black bg-opacity-75 text-white p-3 rounded text-xs max-w-xs">
      <div><strong>Debug Info:</strong></div>
      <div>Path: {location.pathname}</div>
      <div>Auth: {isAuthenticated ? '✅' : '❌'}</div>
      <div>Loading: {isLoading ? '⏳' : '✅'}</div>
      <div>User: {user?.name || 'None'}</div>
      <div>Role: {user?.role || 'None'}</div>
      {error && <div>Error: {error}</div>}
    </div>
  )
}
